<div class="row">
  <div class="col col-3 px-0">
    <common-ui-navigation
      [disableNavigation]="disableNavigation"
      [navigationConfig]="navigationProvider.navigationConfig">
    </common-ui-navigation>
  </div>
  <div class="col col-9 pl-9 pr-0">
    <div class="col-12 pl-4x p-xl-8x questionnaire-content">
      <router-outlet></router-outlet>
      <div class="btn-bar save-btn mt-1hx mb-1hxt">
        <button
          *ngIf="currentItemIndex > 0 && navigationProvider.navigationPages[currentItemIndex]?.id !== 'navigationAntragVersenden'"
          [routerLink]="navigationProvider.navigationPages[currentItemIndex-1]?.route"
          class="btn btn-default"
          id="navigatePrevButton">
          {{ 'COMMON_UI.NAVIGATION.ZURUECK_BUTTON' | translate }}
        </button>
        <button
          (click)="onValidateButtonClick()" *ngIf="!readonly && navigationProvider.navigationPages[currentItemIndex]?.id !== 'navigationAntragVersenden'"
          class="btn btn-default"
          id="validateButton">
          {{ 'COMMON_UI.NAVIGATION.VALIDATE_BUTTON' | translate }}
        </button>
        <button
          *ngIf="currentItemIndex < navigationProvider.navigationPages?.length -1"
          [routerLink]="navigationProvider.navigationPages[currentItemIndex+1]?.route"
          class="btn btn-primary"
          id="navigateNextButton">
          {{ 'COMMON_UI.NAVIGATION.WEITER_BUTTON' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<common-ui-footer extraCss="questionnaire-footer offset-sm-3"></common-ui-footer>
